import { createTagRepeat, optimizeTemplateHTML } from '../../lib/utils.js';
var daysTemplate = optimizeTemplateHTML("<div class=\"days\">\n  <div class=\"days-of-week\">".concat(createTagRepeat('span', 7, {
  class: 'dow'
}), "</div>\n  <div class=\"datepicker-grid\">").concat(createTagRepeat('span', 42), "</div>\n</div>"));
export default daysTemplate;